module.exports = __webpack_public_path__ + "img/instagram.8032e72f.svg";